var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgMint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 264,
    viewBox: "0 0 423 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1026_403)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 423,
    height: 264,
    fill: "#D9FFD8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.868 409.578C615.868 429.694 632.174 446 652.289 446L803.578 446C823.694 446 840 429.693 840 409.578C840 389.463 823.694 373.157 803.578 373.157L652.289 373.157C632.174 373.157 615.868 389.463 615.868 409.578Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.421 221.868C178.306 221.868 162 238.174 162 258.289L162 409.579C162 429.694 178.306 446 198.422 446C218.537 446 234.843 429.694 234.843 409.579L234.843 258.289C234.843 238.174 218.536 221.868 198.421 221.868Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M803.578 -7.86782C823.694 -7.86783 840 -24.1743 840 -44.2893L840 -195.579C840 -215.694 823.693 -232 803.578 -232C783.463 -232 767.157 -215.694 767.157 -195.579L767.157 -44.2893C767.157 -24.1743 783.463 -7.86782 803.578 -7.86782Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.132 -195.579C386.132 -215.694 369.826 -232 349.711 -232L198.421 -232C178.306 -232 162 -215.693 162 -195.578C162 -175.463 178.306 -159.157 198.421 -159.157L349.711 -159.157C369.826 -159.157 386.132 -175.464 386.132 -195.579Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162 258.289C162 278.404 178.306 294.711 198.421 294.711L349.711 294.711C369.826 294.711 386.132 278.404 386.132 258.289C386.132 238.174 369.826 221.868 349.711 221.868L198.421 221.868C178.306 221.868 162 238.174 162 258.289Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.289 294.711C672.404 294.711 688.711 278.404 688.711 258.289L688.711 107C688.711 86.8849 672.404 70.5785 652.289 70.5785C632.174 70.5785 615.868 86.8849 615.868 107L615.868 258.289C615.868 278.404 632.174 294.711 652.289 294.711Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M840 -44.2893C840 -64.4044 823.693 -80.7108 803.578 -80.7108L652.289 -80.7107C632.174 -80.7107 615.868 -64.4043 615.868 -44.2893C615.868 -24.1742 632.174 -7.86778 652.289 -7.86778L803.578 -7.86782C823.694 -7.86783 840 -24.1743 840 -44.2893Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.711 -80.7108C329.596 -80.7108 313.289 -64.4043 313.289 -44.2893L313.289 107C313.289 127.115 329.596 143.421 349.711 143.421C369.826 143.421 386.132 127.115 386.132 107L386.132 -44.2893C386.132 -64.4043 369.826 -80.7108 349.711 -80.7108Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M803.578 294.711C823.694 294.711 840 278.404 840 258.289C840 154.623 755.956 70.5784 652.289 70.5785C632.174 70.5785 615.868 86.8849 615.868 107C615.868 127.115 632.174 143.421 652.289 143.421C715.726 143.421 767.157 194.853 767.157 258.289C767.157 278.404 783.463 294.711 803.578 294.711Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.289 409.578C313.289 429.694 329.596 446 349.711 446C453.377 446 537.421 361.956 537.421 258.289C537.421 238.174 521.115 221.868 501 221.868C480.885 221.868 464.579 238.174 464.579 258.289C464.579 321.726 413.147 373.157 349.711 373.157C329.596 373.157 313.289 389.463 313.289 409.578Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M688.711 -195.579C688.711 -215.694 672.404 -232 652.289 -232C548.623 -232 464.578 -147.956 464.578 -44.2893C464.578 -24.1743 480.885 -7.8678 501 -7.8678C521.115 -7.8678 537.421 -24.1743 537.421 -44.2893C537.421 -107.726 588.853 -159.157 652.289 -159.157C672.404 -159.157 688.711 -175.464 688.711 -195.579Z",
    fill: "#3C46FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.421 -80.7108C178.306 -80.7108 162 -64.4043 162 -44.2892C162 59.3771 246.044 143.422 349.711 143.421C369.826 143.421 386.132 127.115 386.132 107C386.132 86.8849 369.826 70.5785 349.711 70.5785C286.274 70.5785 234.843 19.147 234.843 -44.2893C234.843 -64.4043 218.536 -80.7108 198.421 -80.7108Z",
    fill: "#3C46FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1026_403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 423,
    height: 264,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMint);
export default __webpack_public_path__ + "static/media/bg_mint.ea72d1bf3a756dd150e52a4ed92f74a7.svg";
export { ForwardRef as ReactComponent };